import { PipeTransform, Pipe } from '@angular/core';
import { formatDistanceToNow, format } from 'date-fns';
import { enUS, de, tr, faIR, es, pl, ar, vi, fr, el, ru, bg, da, sq, pt, ro, nl, it } from 'date-fns/esm/locale';
import { LocalizationService } from '../services/localization.service';

const langConfig = {
  en: enUS,
  de: de,
  tr: tr,
  fa: faIR,
  es: es,
  pl: pl,
  ar: ar,
  vi: vi,
  fr: fr,
  el: el,
  ru: ru,
  bg: bg,
  da: da,
  sq: sq,
  pt: pt,
  ro: ro,
  nl: nl,
  it: it,
};
@Pipe({ name: 'dateFormat' })
export class DateFormatPipe implements PipeTransform {
  constructor(private _LocalizationService: LocalizationService) {}

  transform(value, formatS: string, lang?: string): any {
    if (value) {
      let date = new Date(value);
      if (value[0] === '/' && value[value.length - 1] === '/') {
        date = new Date(Number(value.replace(/\D/g, '')));
      }
      const formattedDate = format(date, formatS, { locale: langConfig[lang && lang !== 'none' ? lang : this._LocalizationService.LANGCODE] });
      return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1).toLowerCase();
    }
  }
}

@Pipe({ name: 'dateFormatDistance' })
export class DateFormatDistancePipe implements PipeTransform {
  constructor(private _LocalizationService: LocalizationService) {}

  transform(value, lang?: string): any {
    if (value) {
      let date = new Date(value);
      if (value[0] === '/' && value[value.length - 1] === '/') {
        date = new Date(Number(value.replace(/\D/g, '')));
      }
      return formatDistanceToNow(date, { locale: langConfig[lang && lang !== 'none' ? lang : this._LocalizationService.LANGCODE], includeSeconds: true });
    }
  }
}
